import { TemplateRef } from '@angular/core';

import { IIdentity, SortDescriptor, SortSelectionOption } from '.';
import { GridSortMode } from '../enums';

export interface SortConfig<T extends IIdentity> {
  /**
   * @description Define the sort behavior
   * > `Fixed` - static sort (cannot be changed by user interaction)
   * > `ColumnHeader` - default material table sort (sort each column from its header)
   * > `Selection` - external sort (used for partial sort columns - e.g if the sort column is part of a group)
   */
  mode?: GridSortMode;

  /**
   * @description Allow/Deny UI interaction for changing the sorting
   */
  allowSorting?: boolean;

  /**
   * @description Describes the data sort definition based on columns and direction
   */
  definition?: SortDescriptor<T>[];

  /**
   * @description Set a custom template for the `Selection` mode
   */
  selectionTemplate?: TemplateRef<any>;

  /**
   * @description Sets the select options for the `Selection` mode
   */
  selectionOptions?: SortSelectionOption<T>[];
}
